<template>
  <div class="text-display">
    <div class="row">
      <label class="col-sm-4 col-form-label">{{ field.label }}</label>
      <div class="col-sm-8">{{ field.value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextDisplay',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/TextDisplay.vue